import { saveAs } from "file-saver";
import $ from "jquery";
import moment from "moment";
import React, { Component } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import SelectAll from "../controls/selectall";
import Translation from "../translation/translation";

class DeliveriesReport extends Component {
    DeliveriesPage;
    PageSize;
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        this.DeliveriesPage = 0;
        this.PageSize = 10;
        if (!Context.IsLogged()) {
            return;
        }
        var sid = Context.GetContext().Sid;
        var d1 = moment().startOf("day");
        var d2 = moment().endOf("day");

        var data = {
            session: sid,
            dt_from: d1.format("YYYYMMDD HH:mm:ss"),
            dt_to: d2.format("YYYYMMDD HH:mm:ss"),
        };
        var info = Comm.DeliveriesPartnersAndGoods(data);

        this.state = {
            QueryType: "clientsandarticles",
            ShowResult: false,
            StartDateAnd: d1,
            EndDateAnd: d2,
            StartDateOr: moment().startOf("day"),
            EndDateOr: moment().endOf("day"),
            DeliveryReportType: "0",
            AndData: info,
        };

        this.ShowClientsOrArticles = this.ShowClientsOrArticles.bind(this);
        this.ShowClientsAndArticles = this.ShowClientsAndArticles.bind(this);
        this.ChangeStartDateOr = this.ChangeStartDateOr.bind(this);
        this.ChangeEndDateOr = this.ChangeEndDateOr.bind(this);
        this.ChangeStartDateAnd = this.ChangeStartDateAnd.bind(this);
        this.ChangeEndDateAnd = this.ChangeEndDateAnd.bind(this);
        this.FillAndData = this.FillAndData.bind(this);
        this.ChangeIsPartner = this.ChangeIsPartner.bind(this);
        this.PrintElem = this.PrintElem.bind(this);
        this.ShowAndQueryResult = this.ShowAndQueryResult.bind(this);
        this.ShowOrQueryResult = this.ShowOrQueryResult.bind(this);
        this.ShowAndQueryReport = this.ShowAndQueryReport.bind(this);
        this.ShowOrQueryReport = this.ShowOrQueryReport.bind(this);
        this.Export = this.Export.bind(this);
        this.ChangeDeliveryReportType = this.ChangeDeliveryReportType.bind(this);
    }
    Export(content) {
        var html =
            "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8' /></head><body>" +
            content +
            "</body></html>";
        var file = new Blob([html]);
        saveAs(file, "export.xls");
    }

    ChangeDeliveryReportType() {
        if (this.state.DeliveryReportType === "0")
            this.setState({
                DeliveryReportType: "1",
            });
        else
            this.setState({
                DeliveryReportType: "0",
            });
    }

    FillAndData(date1, date2) {
        if (date1 === null) date1 = this.state.StartDateAnd;
        if (date2 === null) date2 = this.state.EndDateAnd;
        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            dt_from: moment(date1).format("YYYYMMDD HH:mm:ss"),
            dt_to: moment(date2).format("YYYYMMDD HH:mm:ss"),
        };
        var info = Comm.DeliveriesPartnersAndGoods(data);
        this.setState({
            StartDateAnd: moment(date1),
            EndDateAnd: moment(date2),
            AndData: info,
        });
    }

    ChangeStartDateAnd(date) {
        var d1 = date;
        var d2 = this.state.EndDateAnd;
        this.FillAndData(d1, d2);
    }

    ChangeEndDateAnd(date) {
        var d1 = this.state.StartDateAnd;
        var d2 = date;
        this.FillAndData(d1, d2);
    }

    ChangeStartDateOr(date) {
        var d1 = date;
        var d2 = this.state.EndDateOr;
        this.FillOrData(d1, d2, null);
    }

    ChangeEndDateOr(date) {
        var d1 = this.state.StartDateOr;
        var d2 = date;
        this.FillOrData(d1, d2, null);
    }

    FillOrData(date1, date2, partner) {
        if (date1 === null) date1 = this.state.StartDateOr;
        if (date2 === null) date2 = this.state.EndDateOr;
        if (partner === null) partner = this.state.IsPartner;
        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            dt_from: moment(date1).format("YYYYMMDD HH:mm:ss"),
            dt_to: moment(date2).format("YYYYMMDD HH:mm:ss"),
        };

        var info = Comm.DeliveriesPartnersAndGoods(data, partner);
        this.setState({
            StartDateOr: moment(date1),
            EndDateOr: moment(date2),
            IsPartner: partner,
            OrData: info,
            PartnerOrGood: partner,
        });
    }

    ChangeIsPartner(value) {
        this.FillOrData(null, null, value);
    }

    ShowClientsOrArticles() {
        this.setState({
            QueryType: "clientsorarticles",
            ShowResult: false,
        });
        this.FillOrData(null, null, true);
    }

    ShowClientsAndArticles() {
        this.setState({
            QueryType: "clientsandarticles",
            ShowResult: false,
        });
        this.FillAndData(null, null);
    }

    ShowAndQueryReport(forExport = false) {
        var date1 = this.state.StartDateAnd;
        var date2 = this.state.EndDateAnd;

        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            from_dt: moment(date1).format("YYYYMMDD HH:mm:ss"),
            to_dt: moment(date2).format("YYYYMMDD HH:mm:ss"),
        };
        var partners = [];
        $("input[id^=cbPartner]:checked").each(function (i, e) {
            partners.push(parseInt($(e).attr("permvalue"), 10));
        });
        data.partners =
            this.state.QueryType === "ShowDelivery" && this.state.AndOrOrReport && this.state.AndOrOrReport.partners
                ? this.state.AndOrOrReport.partners
                : JSON.stringify(partners);

        var goods = [];
        $("input[id^=cbGood]:checked").each(function (i, e) {
            goods.push(parseInt($(e).attr("permvalue"), 10));
        });
        data.goods =
            this.state.QueryType === "ShowDelivery" && this.state.AndOrOrReport && this.state.AndOrOrReport.goods 
                ? this.state.AndOrOrReport.goods
                : JSON.stringify(goods);
        data.lang = Translation.CurrentLanguage().toLowerCase();
        if (forExport) {
            data.export = 1;
        }
        var pl = Comm.DeliveriesByPartnersAndGoods(data, this.state.DeliveryReportType);
        pl = pl + "<nocache id='" + moment().format() + "'/>";

        if (forExport) {
            this.Export(pl);
        } else {
            this.setState({
                QueryType: "ShowDelivery",
                DeliveryHtml: pl,
                AndOrOrReport: { report: "ShowAndQueryReport", partners: data.partners, goods: data.goods },
            });
        }
    }

    ShowOrQueryReport(forExport = false) {
        var date1 = this.state.StartDateOr;
        var date2 = this.state.EndDateOr;

        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            from_dt: moment(date1).format("YYYYMMDD HH:mm:ss"),
            to_dt: moment(date2).format("YYYYMMDD HH:mm:ss"),
        };
        if (forExport) {
            data.export = 1;
        }
        var pl = null;
        if (this.state.PartnerOrGood) {
            var partners = [];
            $("input[id^=cbPartner]:checked").each(function (i, e) {
                partners.push(parseInt($(e).attr("permvalue"), 10));
            });
            data.partners =
                this.state.QueryType === "ShowDelivery" &&  this.state.AndOrOrReport && this.state.AndOrOrReport.partners
                    ? this.state.AndOrOrReport.partners
                    : JSON.stringify(partners);
            data.lang = Translation.CurrentLanguage().toLowerCase();

            pl = Comm.DeliveriesByPartners(data, this.state.DeliveryReportType);
        } else {
            var goods = [];
            $("input[id^=cbGood]:checked").each(function (i, e) {
                goods.push(parseInt($(e).attr("permvalue"), 10));
            });
            data.goods =
                this.state.QueryType === "ShowDelivery" && this.state.AndOrOrReport && this.state.AndOrOrReport.goods
                    ? this.state.AndOrOrReport.goods
                    : JSON.stringify(goods);
            data.lang = Translation.CurrentLanguage().toLowerCase();

            pl = Comm.DeliveriesByGoods(data, this.state.DeliveryReportType);
        }

        pl = pl + "<nocache id='" + moment().format() + "'/>";

        if (forExport) {
            this.Export(pl);
        } else {
            this.setState({
                QueryType: "ShowDelivery",
                DeliveryHtml: pl,
                AndOrOrReport: { report: "ShowOrQueryReport", partners: data.partners, goods: data.goods },
            });
        }
    }

    ShowAndQueryResult(pageInc, first) {
        var data;
        if (first) {
            var date1 = this.state.StartDateAnd;
            var date2 = this.state.EndDateAnd;

            var sid = Context.GetContext().Sid;
            data = {
                session: sid,
                from_dt: moment(date1).format("YYYYMMDD HH:mm:ss"),
                to_dt: moment(date2).format("YYYYMMDD HH:mm:ss"),
                page: 0,
                pagesize: this.PageSize,
            };

            var partners = [];
            $("input[id^=cbPartner]:checked").each(function (i, e) {
                partners.push(parseInt($(e).attr("permvalue"), 10));
            });
            data.partners = JSON.stringify(partners);

            var goods = [];
            $("input[id^=cbGood]:checked").each(function (i, e) {
                goods.push(parseInt($(e).attr("permvalue"), 10));
            });
            data.goods = JSON.stringify(goods);
        } else {
            data = JSON.parse(this.state.AndData);
            data.page = data.page + pageInc;
        }
        data.lang = Translation.CurrentLanguage().toLowerCase();

        var pl = Comm.DeliveriesByPartnersAndGoods(data);
        this.setState({
            AndData: JSON.stringify(data),
            DeliveryQueryPage: data.page,
            QueryType: "queryresult",
            AndOrOr: "and",
            DeliveryQueryResult: pl,
        });
    }

    ShowOrQueryResult(pageInc, first) {
        var data;
        if (first) {
            var date1 = this.state.StartDateOr;
            var date2 = this.state.EndDateOr;

            var sid = Context.GetContext().Sid;
            data = {
                session: sid,
                from_dt: moment(date1).format("YYYYMMDD HH:mm:ss"),
                to_dt: moment(date2).format("YYYYMMDD HH:mm:ss"),
                page: 0,
                pagesize: this.PageSize,
            };

            if (this.state.PartnerOrGood) {
                var partners = [];
                $("input[id^=cbPartner]:checked").each(function (i, e) {
                    partners.push(parseInt($(e).attr("permvalue"), 10));
                });
                data.partners = JSON.stringify(partners);
            } else {
                var goods = [];
                $("input[id^=cbGood]:checked").each(function (i, e) {
                    goods.push(parseInt($(e).attr("permvalue"), 10));
                });
                data.goods = JSON.stringify(goods);
            }
        } else {
            data = JSON.parse(this.state.OrData);
            data.page = data.page + pageInc;
        }
        data.lang = Translation.CurrentLanguage().toLowerCase();

        var pl = this.state.PartnerOrGood ? Comm.DeliveriesByPartners(data) : Comm.DeliveriesByGoods(data);
        this.setState({
            OrData: JSON.stringify(data),
            DeliveryQueryPage: data.page,
            QueryType: "queryresult",
            AndOrOr: "or",
            DeliveryQueryResult: pl,
        });
    }

    RotateColumns(document) {
        var headings = document.getElementsByClassName("vert");
        for (var iter = 0; iter < headings.length; iter++) {
            var h = headings[iter];
            var label = h.innerText.trim();
            h.innerHTML = "";
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            context.font = h.style.font;
            context.textAlign = "right";
            context.save();
            var metrics = context.measureText(label);
            canvas.height = parseInt(metrics.width, 10);
            canvas.width = context.measureText("M").width; //най-точно приближение
            context.restore();
            context.font = h.style.font;
            //context.fillStyle = "#ff0000"; // red
            context.textAlign = "right";

            // hold top-right hand corner when rotating
            context.translate(canvas.width - 1, 0);
            //context.translate(0, 0);

            context.rotate((3 * Math.PI) / 2);

            context.fillText(label, 0, 0);
            h.appendChild(canvas);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.RotateColumns(document);
    }

    PrintElem() {
        var mywindow = window.open("", "PRINT", "height=400,width=600");

        mywindow.document.write("<html><head><title>" + document.title + "</title>");
        mywindow.document.write("<style>@media print {@page {size: landscape}}</style>");
        mywindow.document.write("</head><body >");
        //mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(this.state.DeliveryHtml);
        mywindow.document.write("</body></html>");

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        this.RotateColumns(mywindow.document);
        mywindow.print();
        mywindow.close();

        return true;
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        return Context.HasRight("rdeliveriesreport") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("deliveries")}</div>
                <div className="panel-body">
                    <div className="col-md-4"></div>
                    <div className="col-md-4">
                        <button
                            type="button"
                            className={
                                this.state.QueryType === "clientsandarticles"
                                    ? "btn btn-warning"
                                    : "btn btn-default"
                            }
                            onClick={() => this.ShowClientsAndArticles()}
                        >
                            {Translation.Trans("byclientsandarticles")}
                        </button>
                    </div>
                    <div className="col-md-4">
                        <button
                            type="button"
                            className={
                                this.state.QueryType === "clientsorarticles"
                                    ? "btn btn-warning"
                                    : "btn btn-default"
                            }
                            onClick={() => this.ShowClientsOrArticles()}
                        >
                            {Translation.Trans("byclientsorarticles")}
                        </button>
                    </div>
                    <p>&nbsp;</p>
                    {this.state.QueryType === "queryresult" ? (
                        <div className="col-md-12">
                            <div className="col-md-12">
                                {this.state.DeliveryQueryResult.packing_lists ? (
                                    <table className="table table-striped">
                                        <tbody>
                                            {this.state.DeliveryQueryResult.packing_lists.map((item) => (
                                                <tr>
                                                    <td>{item.date}</td>
                                                    <td>{item.name}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-default"
                                                            onClick={() => this.ShowDelivery(item.id)}
                                                        >
                                                            {Translation.Trans("show")}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : null}
                            </div>
                            <div className="col-md-1">
                                {this.state.DeliveryQueryPage > 0 ? (
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        onClick={
                                            this.state.AndOrOr === "and"
                                                ? () => this.ShowAndQueryResult(-1, false)
                                                : () => this.ShowOrQueryResult(-1, false)
                                        }
                                    >
                                        &lt;&lt;
                                    </button>
                                ) : null}
                            </div>
                            <div className="col-md-1">
                                {(this.state.DeliveryQueryPage + 1) * this.PageSize <
                                this.state.DeliveryQueryResult.count ? (
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        onClick={
                                            this.state.AndOrOr === "and"
                                                ? () => this.ShowAndQueryResult(1, false)
                                                : () => this.ShowOrQueryResult(1, false)
                                        }
                                    >
                                        &gt;&gt;
                                    </button>
                                ) : null}
                            </div>
                        </div>
                    ) : null}
                    {this.state.QueryType === "clientsandarticles" ? (
                        <div className="col-md-12">
                            <div className="col-md-4">
                                <label htmlFor="dpStartDateAnd">{Translation.Trans("FromDate")}</label>
                                <Datetime
                                    inputProps={{
                                        placeholder: "N/A",
                                        readOnly: true,
                                        className: "form-control pointhand",
                                    }}
                                    dateFormat="DD.MM.YYYY"
                                    timeFormat="HH:mm:ss"
                                    onChange={this.ChangeStartDateAnd}
                                    value={this.state.StartDateAnd}
                                    closeOnSelect={true}
                                ></Datetime>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="dpEndDateAnd">{Translation.Trans("ToDate")}</label>
                                <Datetime
                                    inputProps={{
                                        placeholder: "N/A",
                                        readOnly: true,
                                        className: "form-control pointhand",
                                    }}
                                    dateFormat="DD.MM.YYYY"
                                    timeFormat="HH:mm:ss"
                                    onChange={this.ChangeEndDateAnd}
                                    value={this.state.EndDateAnd}
                                    closeOnSelect={true}
                                ></Datetime>
                            </div>
                            <div className="col-md-2">
                                <br />
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    onClick={() => this.ShowAndQueryReport()}
                                >
                                    {Translation.Trans("report")}
                                </button>
                            </div>
                            <div className="col-md-2">
                                <br />
                                <select
                                    className="form-control"
                                    value={this.state.DeliveryReportType}
                                    onChange={() => this.ChangeDeliveryReportType()}
                                >
                                    <option value="0">{Translation.Trans("deliveryarrived")}</option>
                                    <option value="1">{Translation.Trans("deliveryall")}</option>
                                </select>
                            </div>
                            <div className="col-md-6">
                                {this.state.AndData && this.state.AndData.partners ? (
                                    <div>
                                        <SelectAll cbid="cbPartner_"></SelectAll>
                                        {this.state.AndData.partners.map((item) => (
                                            <div key={"cbPartner_" + item.id} className="checkbox">
                                                <input
                                                    id={"cbPartner_" + item.id}
                                                    type="checkbox"
                                                    permvalue={item.id}
                                                    key={"andpartner" + item.id}
                                                />
                                                <label htmlFor={"cbPartner_" + item.id}>{item.name}</label>
                                            </div>
                                        ))}
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-md-6">
                                {this.state.AndData && this.state.AndData.goods ? (
                                    <div>
                                        <SelectAll cbid="cbGood_"></SelectAll>
                                        {this.state.AndData.goods.map((item) => (
                                            <div key={"cbGood_" + item.id} className="checkbox">
                                                <input
                                                    id={"cbGood_" + item.id}
                                                    type="checkbox"
                                                    permvalue={item.id}
                                                    key={"andgood" + item.id}
                                                />
                                                <label htmlFor={"cbGood_" + item.id}>{item.name}</label>
                                            </div>
                                        ))}
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-md-6"></div>
                        </div>
                    ) : null}
                    {this.state.QueryType === "clientsorarticles" && !this.state.ShowResult ? (
                        <div className="col-md-12">
                            <div className="col-md-4">
                                <label htmlFor="dpStartDateAnd">{Translation.Trans("FromDate")}</label>
                                <Datetime
                                    inputProps={{
                                        placeholder: "N/A",
                                        readOnly: true,
                                        className: "form-control pointhand",
                                    }}
                                    dateFormat="DD.MM.YYYY"
                                    timeFormat="HH:mm:ss"
                                    onChange={this.ChangeStartDateOr}
                                    value={this.state.StartDateOr}
                                    closeOnSelect={true}
                                ></Datetime>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="dpEndDateAnd">{Translation.Trans("ToDate")}</label>
                                <Datetime
                                    inputProps={{
                                        placeholder: "N/A",
                                        readOnly: true,
                                        className: "form-control pointhand",
                                    }}
                                    dateFormat="DD.MM.YYYY"
                                    timeFormat="HH:mm:ss"
                                    onChange={this.ChangeEndDateOr}
                                    value={this.state.EndDateOr}
                                    closeOnSelect={true}
                                ></Datetime>
                            </div>
                            <div className="col-md-2">
                                <br />
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    onClick={() => this.ShowOrQueryReport()}
                                >
                                    {Translation.Trans("report")}
                                </button>
                            </div>
                            <div className="col-md-2">
                                <br />
                                <select
                                    className="form-control"
                                    value={this.state.DeliveryReportType}
                                    onChange={() => this.ChangeDeliveryReportType()}
                                >
                                    <option value="0">{Translation.Trans("deliveryarrived")}</option>
                                    <option value="1">{Translation.Trans("deliveryall")}</option>
                                </select>
                            </div>

                            <div className="col-md-6">
                                <div className="radio">
                                    <input
                                        id="rbIsPartner_1"
                                        type="radio"
                                        name="IsPartner"
                                        onChange={() => this.ChangeIsPartner(true)}
                                        defaultChecked={true}
                                    />
                                    <label htmlFor="rbIsPartner_1">{Translation.Trans("byclients")}</label>
                                </div>
                                <div className="radio">
                                    <input
                                        id="rbIsPartner_2"
                                        type="radio"
                                        name="IsPartner"
                                        onChange={() => this.ChangeIsPartner(false)}
                                    />
                                    <label htmlFor="rbIsPartner_2">{Translation.Trans("byarticles")}</label>
                                </div>
                            </div>
                            <div className="col-md-6">
                                {this.state.IsPartner ? (
                                    this.state.OrData.partners ? (
                                        <div>
                                            <SelectAll cbid="cbPartner_"></SelectAll>
                                            {this.state.OrData.partners.map((item) => (
                                                <div key={"cbPartner_" + item.id} className="checkbox">
                                                    <input
                                                        id={"cbPartner_" + item.id}
                                                        type="checkbox"
                                                        permvalue={item.id}
                                                        key={"orpartner" + item.id}
                                                    />
                                                    <label htmlFor={"cbPartner_" + item.id}>
                                                        {item.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    ) : null
                                ) : this.state.OrData.goods ? (
                                    <div>
                                        <SelectAll cbid="cbGood_"></SelectAll>
                                        {this.state.OrData.goods.map((item) => (
                                            <div key={"cbGood_" + item.id} className="checkbox">
                                                <input
                                                    id={"cbGood_" + item.id}
                                                    type="checkbox"
                                                    permvalue={item.id}
                                                    key={"orgood" + item.id}
                                                />
                                                <label htmlFor={"cbGood_" + item.id}>{item.name}</label>
                                            </div>
                                        ))}
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-md-6"></div>
                        </div>
                    ) : null}
                    {this.state.QueryType === "ShowDelivery" ? (
                        <div className="row">
                            <div
                                className="col-md-12"
                                id="dDelivery"
                                dangerouslySetInnerHTML={{ __html: this.state.DeliveryHtml }}
                            ></div>
                            {console.log(this.state)}
                            <div className="col-md-12">
                                <button className="btn btn-primary" onClick={this.PrintElem}>
                                    <i className="fa fa-print"></i>
                                    <p>{Translation.Trans("print")}</p>
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        var CUSTOMER = window.CONFIG
                                            && window.CONFIG.CUSTOMER;
                                            // : process.env.REACT_APP_CUSTOMER;
                                        if (
                                            CUSTOMER === "HUMANA" &&
                                            this.state.AndOrOrReport &&
                                            this.state.AndOrOrReport.report === "ShowAndQueryReport"
                                        ) {
                                            this.ShowAndQueryReport(true);
                                        } else if (
                                            CUSTOMER === "HUMANA" &&
                                            this.state.AndOrOrReport &&
                                            this.state.AndOrOrReport.report === "ShowOrQueryReport"
                                        ) {
                                            this.ShowOrQueryReport(true);
                                        } else {
                                            this.Export(this.state.DeliveryHtml);
                                        }
                                    }}
                                >
                                    <i className="fas fa-table"></i>
                                    <p>{Translation.Trans("export")}</p>
                                </button>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default DeliveriesReport;



// WEBPACK FOOTER //
// ./src/pages/deliveriesreport.js